import { whiteColor, primaryColor } from 'assets/jss/material-dashboard-pro-react';
const tryAndBuyFBBDialogStyle = (theme) => ({
	wrapper: {
		backgroundColor: whiteColor,
		borderRadius: 4,
		width: '100%',
		display: 'flex',
		justify: 'flex-start',
		flexDirection: 'column',
		padding: '32px 32px 0px 32px',
	},
	fbbDescriptionWrapper: {
		marginBottom: '20px',
		'& .mt': {
			marginTop: '15px',
			display: 'block',
		},
		'& a': {
			color: primaryColor[0],
		},
	},
	fbbPolicyWrapper: {
		marginTop: '42px',
	},
	fbbPlanSectionWrapper: {
		marginTop: '32px',
	},
	fbbPlanWrapper: {
		backgroundColor: '#f8f8f8',
		marginBottom: '20px',
		padding: '16px',
		[theme.breakpoints.down('xs')]: {
			padding: '5px',
			'& p:first-of-type': {
				fontSize: '12px',
			},
			'& p:last-of-type': {
				fontSize: '14px',
			},
		},
	},
	fbbCurrentPlanWrapper: {},
	fbbNewPlanWrapper: {
		backgroundColor: '#f8f8f8',
	},
	fbbNewCurrenPlanWrapper: {
		display: 'flex',
		justify: 'flex-start',
		flexDirection: 'row',
		marginTop: '9px',
		marginBottom: '18px',
	},
	arrow: {
		marginLeft: '25px',
		marginRight: '25px',
	},
	chooseNumber: {
		width: 288,
		maxWidth: '100%',
		margin: 'left',
	},
	fbbNewPlan: {
		backgroundColor: '#F0F8FC',
	},
});

export default tryAndBuyFBBDialogStyle;
